import React from 'react';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import IntegrationReactSelectNew from './IntegrationReactSelectNew';
import InputBox from './InputBox';
import _ from 'lodash';
import '../css/SystemIntegratorAdd.css';
import ErrorText from '../ErrorText';
// import cities from './cities';
import Loader from './Loader';
import SnackBar from './SnackBar';


// Knowledge Bank page to add new Knowledge Bank page

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '40px 90px 40px 90px',
        marginLeft: '260px',
        marginTop: '3%',
        backgroundColor: '#EFF3F6',
        // background: 'none !important'
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};


const customStylesSuccess = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        minHeight: '50%',
        maxHeight: '90%',
        overflow: 'auto',
        padding: '40px 90px 40px 90px',
        marginLeft: '260px',
        marginTop: '3%',
        background: '#EFF3F6',
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "none"
    },
};



export default class KnowledgeAddNew extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalIsOpen: this.props.activeModal,
            modalStateAftereOpen: 'animated animated-duration-custom slideInDown',
            modalStateAftereOpenSuccess: 'animated animated-duration-custom slideInDown',
            noOfParams: [],
            KnowledgeTitle: '',
            KnowledgeVideo: null,
            KnowledgeDescription: '',
            KnowledgYoutubeVideo: '',
            uploadedFile: null,
            errorMessage: [],
            modalIsOpenSuccess: false,
            showErrorMessage: false,
            usernameAvailable: true,
            knowledgeBankData: [],
            loader: false,
            snackbarActive: false,
            snackbarMessage: ''
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.closeModalSuccess = this.closeModalSuccess.bind(this);

    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    closeModalSuccess() {
        this.setState({
            modalStateAftereOpenSuccess: 'animated animated-duration-custom slideOutUp',
            modalIsOpen: false
        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpenSuccess: false
                }, () => this.props.closeAllModal())
            }, 500);
        })
    }


    afterOpenModal() {

    }

    closeModal() {
        this.setState({
            modalStateAftereOpen: 'animated animated-duration-custom slideOutUp',
            title: '',
            video: '',
            description: '',
        }, () => {
            setTimeout(() => {
                this.setState({
                    modalIsOpen: false
                }, () => this.props.closeAllModal())
            }, 500);
        })
    }


    componentDidMount() {
        this.fecthAllKnowledgeBank();
    }

    fecthAllKnowledgeBank = () => {
        var tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;
        var headers = {
            'Content-Type': 'application/json',
            "Access-Control-Allow-Origin": "*",
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            'Authorization': tokenStored
        }
        fetch('/cloud/video-library/', { // Change to Knowledge Bank
            method: "GET",
            headers: headers,
        })
            .then(response => {
                if (response.status === 403) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true })
                    window.location.href = '/session-timeout'
                } else {
                    return response.json()
                }
            })
            .then(data => {
                this.setState({
                    knowledgeBankData: data
                })
                console.log(data)
            })
            .catch((err) => {
                console.log(err)
            })
    }


    AddingKnowledgeBank = () => {
        const { KnowledgeTitle: title, KnowledgeVideo: video, KnowledgeDescription: description, KnowledgYoutubeVideo: yt_video } = this.state;
        // console.log(this.state.KnowledgYoutubeVideo)

        // Retrieve token from localStorage
        let tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;

        // Create FormData object to handle file upload
        const formData = new FormData();
        formData.append('title', title);
        formData.append('video', video); // File
        formData.append('description', description);
        formData.append('yt_video', yt_video);

        // Define headers for the request
        const headers = {
            "Authorization": tokenStored,
            'X-CSRFToken': localStorage.getItem('csrftoken'), // CSRF token if required
        };

        // Send data to the server using fetch and FormData
        fetch('/cloud/video-library/', {
            method: "POST",
            headers,  // Do not set 'Content-Type' for FormData, browser handles it
            body: formData,  // Send the form data including the file
        })
            .then(response => {
                if (response.status === 403) {
                    // Handle session timeout by redirecting to session timeout page
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true });
                    window.location.href = '/session-timeout'
                } else {
                    return response.json();  // Parse the response as JSON
                }
            })
            .then(data => {
                if (data.message !== "failure") {
                    // Successfully added data, close modal and show success message
                    this.setState({
                        modalIsOpen: false,  // Close the modal immediately
                        modalIsOpenSuccess: true,  // Show success message
                        loader: false,  // Hide loading spinner
                        KnowledgeTitle: '',  // Clear the title field
                        KnowledgeVideo: null,  // Reset the file field
                        KnowledgeDescription: '',  // Clear the description field
                        KnowledgYoutubeVideo: '',
                        showErrorMessage: false,  // Hide error message
                    });

                    // Fetch updated list of KnowledgeBank's or any other data
                    this.fecthAllKnowledgeBank();
                } else {
                    // Failure: Show error message
                    this.setState({
                        loader: false,
                        snackbarActive: true,  // Activate the snackbar
                        snackbarMessage: `${Object.keys(data.data)[0]}: ${data.data[Object.keys(data.data)[0]]}`,
                    });
                }
            })
            .catch(err => {
                console.log(err);  // Log any error that occurs during the fetch request
            });
    };






    AddingAnotherKnowledgeBank = () => {
        const { KnowledgeTitle: title, KnowledgeVideo: video, KnowledgeDescription: description, KnowledgYoutubeVideo: yt_video } = this.state;

        // Retrieve token
        let tokenStored = localStorage.getItem('token');
        tokenStored = `Token ${tokenStored}`;

        // Create FormData object
        const formData = new FormData();
        formData.append('title', title);
        formData.append('video', video); // Add the file object
        formData.append('description', description);
        formData.append('yt_video', yt_video);

        const headers = {
            "Authorization": tokenStored,
            'X-CSRFToken': localStorage.getItem('csrftoken'), // CSRF token if required
        };

        // Fetch request
        fetch('/cloud/video-library/', {
            method: "POST",
            headers, // Note: Do not add 'Content-Type' when using FormData; the browser sets it automatically
            body: formData,
        })
            .then((response) => {
                if (response.status === 403) {
                    // Handle session timeout
                    localStorage.removeItem('token');
                    localStorage.removeItem('csrftoken');
                    localStorage.removeItem('auth');
                    // const history = createHistory({ forceRefresh: true });
                    window.location.href = '/session-timeout'
                } else {
                    return response.json();
                }
            })
            .then((data) => {
                if (data.message !== "failure") {
                    this.setState({
                        modalIsOpen: false,
                        addAnotherSuccess: true,
                        knowledgeBankData: data
                    }, () => {
                        setTimeout(() => {
                            this.setState({ addAnotherSuccess: false });
                        }, 3000);

                        this.setState({
                            modalIsOpen: true,
                            KnowledgeTitle: '',
                            KnowledgeVideo: null, // Reset to null instead of an empty string
                            KnowledgeDescription: '',
                            KnowledgYoutubeVideo: '',
                            showErrorMessage: false,
                            loader: false,
                        }, () => this.fecthAllKnowledgeBank());
                    });
                } else {
                    alert('Video with same details already added');
                    // const history = createHistory({ forceRefresh: true });
                    window.location.href = '/distributor/Knowledge'
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };




    AddKnowledgeBank = () => {
        this.setState({
            showErrorMessage: true
        }, () => {
            this.fetchError((e) => {
                if (e === 'NoError') {
                    this.setState({
                        loader: true
                    }, () => this.AddingKnowledgeBank())
                }
            })
        })
    }


    // AddKnowledgeBank = () => {
    //     this.setState(
    //         {
    //             showErrorMessage: true,
    //             loader: true
    //         },
    //         () => this.AddingKnowledgeBank()
    //     );
    // };




    AddAnotherKnowledgeBank = () => {
        this.setState({
            showErrorMessage: true
        }, () => {
            this.fetchError((e) => {
                if (e === 'NoError') {
                    this.setState({
                        loader: true
                    }, () => this.AddingAnotherKnowledgeBank())
                }
            })
        }
        )
    }

    // AddAnotherKnowledgeBank = () => {
    //     this.setState(
    //         {
    //             showErrorMessage: true,
    //             loader: true
    //         },
    //         () => this.AddingAnotherKnowledgeBank()
    //     );
    // };





    checkKnowledgeBankTitle = (e) => {
        let data = '';
        this.state.knowledgeBankData.forEach((e) => {
            console.log(e.title);
            if (e.title === this.state.KnowledgeTitle) {
                data = 'title exist';
            }
        })
        if (data === 'title exist') {
            this.setState({
                usernameAvailable: false
            })
        }
        // console.log('Data:', data); 
    }

    fetchError = (noError) => {
        var totalError = 2;

        if (ErrorText('notEmpty', this.state.KnowledgeTitle) === 'No Error') {
            totalError = totalError - 1;
        }

        if (ErrorText('notEmpty', this.state.KnowledgeDescription) === 'No Error') {
            totalError = totalError - 1;
        }



        if (totalError === 0) {
            noError('NoError');
        }
    }

    handleChangeInputBox = (name, event) => {
        this.setState({
            [name]: event
        }, () => {
            if (true) {
                this.checkKnowledgeBankTitle()
            }
        });
    }
    handleFileUpload(event) {
        const file = event.target.files[0];
        // Update the file type to accept video formats (e.g., MP4, AVI, etc.)
        if (file && file.type.startsWith('video/')) {
            this.setState({ KnowledgeVideo: file, showErrorMessage: false, uploadedFile: file });
        } else {
            this.setState({ KnowledgeVideo: null, showErrorMessage: true });
            alert('Please upload a valid Video file.');
        }
    }




    render() {
        return (
            <React.Fragment>
                <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
                    this.setState({
                        snackbarActive: false
                    })
                }} message={this.state.snackbarMessage} />
                {this.state.loader ? <Loader /> : null}
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    className={this.state.modalStateAftereOpen}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModal}>
                            <i class="fas fa-timess fa-2x mr-2"></i>
                        </div>
                    </div>
                    <h3 className="modal-heading text-uppercase mb-0" style={{ color: '#888888', fontSize: '30px', }}>Add Video</h3>
                    <div className="row">
                        {this.state.addAnotherSuccess ? <div class="col-12 my-2 alert alert-success fade show" role="alert">
                            Successfully added the Video.
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            </button>
                        </div> : null}
                    </div>
                    <div className="row">
                        <div className="col-6 mx-0 px-0" >
                            <InputBox
                                inputText={this.state.KnowledgeTitle}
                                error={ErrorText('notEmpty', this.state.KnowledgeTitle) !== 'No Error' && this.state.showErrorMessage ? true : false}
                                errorText={ErrorText('notEmpty', this.state.KnowledgeTitle) !== 'No Error' && this.state.showErrorMessage ? 'Please enter the Title' : ''}
                                placeholder="Title"
                                inputBoxName="KnowledgeTitle"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                textLength={37}
                                validate={true}
                            />
                        </div>

                        <div className="col-6">

                            <input
                                type="file"
                                accept="video/*"
                                onChange={(event) => this.handleFileUpload(event)}
                                style={{ marginTop: '10px' }}
                                placeholder="Title"
                                disabled={this.state.KnowledgYoutubeVideo}


                            />
                        </div>
                        <div className="col-6 mx-0 px-0 ">
                            <InputBox
                                inputText={this.state.KnowledgeDescription}
                                error={ErrorText('notEmpty', this.state.KnowledgeDescription) !== 'No Error' && this.state.showErrorMessage ? true : false}
                                errorText={ErrorText('notEmpty', this.state.KnowledgeDescription) !== 'No Error' && this.state.showErrorMessage ? 'Please enter Description' : ''}
                                placeholder="Description"
                                inputBoxName="KnowledgeDescription"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                textLength={255}
                                blockSpecialChar={false} // ✅ prevent special char input
                            />
                        </div>
                        <div className="col-6">
                            {/* <InputBox
                                inputText={this.state.KnowledgYoutubeVideo}
                                // error={ErrorText('notEmpty', this.state.KnowledgeDescription) !== 'No Error' && this.state.showErrorMessage ? true : false}
                                // errorText={ErrorText('notEmpty', this.state.KnowledgeDescription) !== 'No Error' && this.state.showErrorMessage ? 'Please enter Description' : ''}
                                placeholder="Youtube Video Link"
                                inputBoxName="KnowledgYoutubeVideo"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                textLength={255}
                             
                            /> */}
                            <InputBox
                                inputText={this.state.KnowledgYoutubeVideo}
                                error={
                                    this.state.KnowledgYoutubeVideo &&
                                    !(
                                        this.state.KnowledgYoutubeVideo.startsWith('https://') &&
                                        /^(https:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//.test(this.state.KnowledgYoutubeVideo)
                                    )
                                }
                                errorText={
                                    this.state.KnowledgYoutubeVideo &&
                                        !(
                                            this.state.KnowledgYoutubeVideo.startsWith('https://') &&
                                            /^(https:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//.test(this.state.KnowledgYoutubeVideo)
                                        )
                                        ? 'Please enter a valid YouTube link starting with https'
                                        : ''
                                }
                                placeholder="Youtube Video Link"
                                inputBoxName="KnowledgYoutubeVideo"
                                handleChangeCustom={this.handleChangeInputBox.bind(this)}
                                textLength={255}
                                disabled={this.state.uploadedFile}
                                blockSpecialChar={false}
                            />

                        </div>




                    </div>
                    <div className="float-right" style={{ marginTop: '70px', marginRight: '-15px' }}>
                        <div className="btn btn-new-grey" style={{ marginRight: '15px' }} onClick={this.closeModal}>Cancel</div>
                        <div className="btn btn-new-orange" style={{ marginRight: '15px' }} onClick={this.AddAnotherKnowledgeBank.bind(this)}>
                            Add Another
                        </div>
                        <i className="fa fa-star-christmas fa-spin"></i>
                        <div className="btn btn-new-green " onClick={this.AddKnowledgeBank.bind(this)}>Add</div>
                    </div>
                </Modal>
                <Modal
                    isOpen={this.state.modalIsOpenSuccess}
                    style={customStylesSuccess}
                    className={this.state.modalStateAftereOpenSuccess}
                    contentLabel="Example Modal">
                    <div className="modal-add-device">
                        <div className="float-right cross-times" onClick={this.closeModalSuccess}>
                            <i className="fas   fa-2x mr-2"></i>
                        </div>
                    </div>
                    <div className="display-4 text-center">
                        <h3 className="modal-heading thanks-message">Video Added Successfully</h3>
                        <i class="fas fa-check-circle update"></i>
                        <br />
                        <div className="btn btn-new-grey"
                            onClick={this.closeModalSuccess}>
                            Close
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}
